/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const customFieldDataTypeSchema = z.enum(['text'])

export type CustomFieldDataTypeSchema = z.infer<typeof customFieldDataTypeSchema>
